import { Outlet } from "react-router";

import { useAuth } from "@/providers/auth-provider";

import { OrgPicker } from "./OrgPicker";
import { Sidebar } from "./Sidebar";

/**
 * App shell: title bar with the org picker, the sidebar, and the routed page.
 *
 * There is no "no access" state for the app as a whole: signing in to the
 * Shadow Realm Kinde environment is itself the authorization, so anyone who
 * gets this far is internal staff or an invited configurator. What they can
 * act on is the organization list, and which menu items they see is the
 * `globalAccess` grant — both from their ShadowAccess record.
 */
export const ShadowLayout = () => {
	const { email, logout } = useAuth();

	return (
		<div className="flex h-dvh flex-col">
			<header className="border-secondary flex items-center justify-between gap-4 border-b px-6 py-4">
				<div className="flex items-center gap-6">
					<h1 className="text-primary text-lg font-semibold">Shadow Realm</h1>
					<OrgPicker />
				</div>

				<div className="flex items-center gap-3">
					{email && <span className="text-tertiary text-sm">{email}</span>}
					<button
						className="text-secondary hover:text-primary text-sm underline"
						onClick={() => void logout()}
						type="button"
					>
						Sign out
					</button>
				</div>
			</header>

			<div className="flex min-h-0 flex-1">
				<Sidebar />
				<main className="flex-1 overflow-auto p-6">
					<Outlet />
				</main>
			</div>
		</div>
	);
};
